import Footer from "../ones/Footer";
import OneProject from "../ones/OneProject";

export default function ProjectDetail(props) {
  const { projectSlug } = props;

  return (
    <>
      <OneProject projectSlug={projectSlug} />
      <Footer />
    </>
  );
}
